var map = {
	"./de/group-logo.png": "YCOk",
	"./en/group-logo.png": "lEpy",
	"./es/group-logo.png": "0y70",
	"./fr/group-logo.png": "iX2l",
	"./ja/group-logo.png": "5Z2l",
	"./ko/group-logo.png": "hkdS",
	"./pt/group-logo.png": "5MTu",
	"./ru/group-logo.png": "w3lP",
	"./tc/group-logo.png": "nNhX",
	"./th/group-logo.png": "94+T"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "zhNi";